import { Stack, Typography } from '@mui/material';
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BaseImage from '../../../../components/common/baseImage';
import { AudioPlayContext } from '../../../../contexts/AudioPlayContext';
import { StateMsgType as StateMsgTypeEnum } from '../../../../models/Popup';
import { SoundList, VoiceList } from '../../../../models/Voice';
import { getInGamePopupSate } from '../../../popup/selector';

export const BlackjackBetResultPopup = () => {
    const { t, i18n } = useTranslation();
    const popupData = useSelector(getInGamePopupSate);
    const { key, stateMsgType, params } = popupData;
    const { audioPlay } = useContext(AudioPlayContext);

    const [message, setMessage] = useState<string>('');
    const [icon, setIcon] = useState<string>('');
    const [textColor, setTextColor] = useState<string>('#ffffff');
    const ref = useRef<boolean>(false); //防止play 2 次
    const [languageDir, setLanguageDir] = useState<string>('ltr');
    const [popupTop, setPopupTop] = useState(60);
    useEffect(() => {
        setLanguageDir(i18n.dir(i18n.language));
    }, [i18n.language]);
    useEffect(() => {
        if (key) {
            let msg: string[] = [];
            if (typeof key === 'string') {
                msg.push(key);
            } else {
                msg = key;
            }
            const includeMultiplier = msg.includes('system.bet_multiplier');
            const transMsg = msg.map(m => t(m, params));
            setPopupTop(includeMultiplier ? 45 : 60);
            setMessage(transMsg.join(' '));

            if (!ref.current) {
                ref.current = true;
                let aKey: Array<string> = [];
                switch (key) {
                    case 'system.bet_success':
                        aKey = [VoiceList.BettingSuccess];
                        break;
                    case 'system.not_enough_money':
                        aKey = [VoiceList.NotEnoughCredit];
                        break;
                    case 'system.bet_exceed_limit_allin':
                        aKey = [SoundList.ChipsBet];
                        break;
                    case 'system.all_in':
                        aKey = [VoiceList.AllIn];
                        break;
                }
                if (aKey && aKey.length > 0) {
                    audioPlay(aKey);
                }
            }
        }
    }, [key, i18n.language]);
    useEffect(() => {
        if (stateMsgType !== StateMsgTypeEnum.betInfo_Normal) {
            switch (stateMsgType) {
                case StateMsgTypeEnum.betInfo_Success:
                    setIcon('commonUI ic_success2');
                    setTextColor('#00ff00');
                    break;
                case StateMsgTypeEnum.betInfo_Fail:
                    setIcon('commonUI ic_failure2');
                    setTextColor('#ff0000');
                    break;
                case StateMsgTypeEnum.betInfo_Warning:
                    setIcon('commonUI ic_warning');
                    setTextColor('#868583');
                    break;
            }
        }
    }, [stateMsgType]);

    return (
        <>
            {message && (
                <>
                    <Stack
                        justifyContent={'center'}
                        alignItems={'center'}
                        spacing={1}
                        sx={{
                            position: 'absolute',
                            minWidth: '460px',
                            top: `${popupTop}%`,
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0,0,0,0.75)',
                            borderRadius: '4px',
                            padding: '15px 0 10px 0',
                            zIndex: theme => theme.zIndex.drawer + 100,
                        }}
                    >
                        {icon && (
                            <>
                                <BaseImage className={icon} scale={1} />
                            </>
                        )}
                        <Typography
                            sx={{
                                color: textColor,
                                fontSize: 35,
                                textAlign: 'center',
                                direction: languageDir,
                            }}
                        >
                            {message}
                        </Typography>
                    </Stack>
                </>
            )}
        </>
    );
};
